import { render, staticRenderFns } from "./NewMessengerTicket.vue?vue&type=template&id=3a96e128&scoped=true"
import script from "./NewMessengerTicket.vue?vue&type=script&lang=js"
export * from "./NewMessengerTicket.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerTicket.vue?vue&type=style&index=0&id=3a96e128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96e128",
  null
  
)

export default component.exports